import { PageViewEventLogger } from '@repo/tracking-service';
import { useAtomValue } from 'jotai';
import { ReactElement, useEffect } from 'react';
import { useQueryLoader } from 'react-relay';

import { businessSignboardQuery } from '@/__generated__/businessSignboardQuery.graphql';
import Spinner from '@/components/common/Spinner';
import { SignboardContainer } from '@/components/survey/business/signboard/SignboardContainer';
import { BusinessProvider } from '@/components/survey/common/BusinessProvider';
import { SurveyProvider } from '@/components/survey/common/SurveyProvider';
import { useSurveyUserEventAttributes } from '@/components/survey/common/hooks/use-survey-user-event-attributes';
import { signboardQuery } from '@/graphql/query/survey/business';
import { currentBusinessBmanTinAtom, refundHistoryIdAtom } from '@/lib/stores/survey/common';

function BusinessSignboardPage() {
  const [queryRef, loadQuery] = useQueryLoader<businessSignboardQuery>(signboardQuery);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const bmanTin = useAtomValue(currentBusinessBmanTinAtom);
  const eventAttributes = useSurveyUserEventAttributes();

  useEffect(() => {
    if (refundHistoryId && bmanTin) {
      loadQuery(
        {
          refundHistoryId,
          bmanTin
        },
        { fetchPolicy: 'network-only' }
      );
    }
  }, [loadQuery, refundHistoryId, bmanTin]);

  if (!queryRef) return <Spinner />;
  return (
    <PageViewEventLogger pageName={'survey_signboard'} eventProperty={eventAttributes}>
      <SignboardContainer queryRef={queryRef} />
    </PageViewEventLogger>
  );
}

BusinessSignboardPage.getLayout = (page: ReactElement) => (
  <SurveyProvider>
    <BusinessProvider>{page}</BusinessProvider>
  </SurveyProvider>
);

export default BusinessSignboardPage;
